import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "no-gutters text-center pb-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    property: "itemListElement",
    typeof: "ListItem"
  }, [
    /*#__PURE__*/_createElementVNode("a", {
      property: "item",
      typeof: "WebPage",
      title: "Go to EveryLink.",
      href: "/",
      class: "home"
    }, [
      /*#__PURE__*/_createElementVNode("span", { property: "name" }, "EveryLink")
    ]),
    /*#__PURE__*/_createElementVNode("meta", {
      property: "position",
      content: "1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, " > "),
  /*#__PURE__*/_createElementVNode("span", {
    property: "itemListElement",
    typeof: "ListItem"
  }, [
    /*#__PURE__*/_createElementVNode("span", { property: "name" }, "People"),
    /*#__PURE__*/_createElementVNode("meta", {
      property: "position",
      content: "3"
    })
  ])
], -1)
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center gap-3 mb-2"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "d-flex justify-content-center" }
const _hoisted_5 = { class: "row no-gutters" }
const _hoisted_6 = { class: "col-12 text-center" }
const _hoisted_7 = {
  key: 1,
  class: "d-inline-block align-middle"
}
const _hoisted_8 = {
  key: 0,
  class: "badge bg-primary d-inline-block"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row no-gutters" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "/profile-edit",
        class: "mb-3 d-block link-secondary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
      }, "Edit Profile")
    ])
  ])
], -1)
const _hoisted_10 = { class: "row no-gutters" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "row no-gutters justify-content-center" }
const _hoisted_13 = { class: "col-12 col-sm-10 col-md-10 col-lg-8 col-xl-6" }
const _hoisted_14 = { class: "pb-3 text-center" }
const _hoisted_15 = { class: "input-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "pt-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-lg btn-primary"
  }, "Post"),
  /*#__PURE__*/_createElementVNode("small", { class: "ms-3" }, [
    /*#__PURE__*/_createElementVNode("small", null, "Or press ENTER to post...")
  ])
], -1)
const _hoisted_17 = {
  key: 0,
  class: "home"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = {
  key: 1,
  class: "home"
}
const _hoisted_20 = {
  key: 0,
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeletor = _resolveComponent("Skeletor")!
  const _component_ChatPeopleBar = _resolveComponent("ChatPeopleBar")!
  const _component_PostCard = _resolveComponent("PostCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
              return _createVNode(_component_Skeletor, {
                key: index,
                width: "140",
                height: "46",
                pill: ""
              })
            }), 64))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.getFriends?.length)
              ? (_openBlock(), _createBlock(_component_ChatPeopleBar, {
                  key: 0,
                  peopleList: _ctx.getFriends
                }, null, 8, ["peopleList"]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_Skeletor, {
            key: 0,
            class: "my-3",
            circle: "",
            size: "120"
          }))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "avatar my-3",
            style: _normalizeStyle({ backgroundImage: `url(${_ctx.getAvatar})` })
          }, null, 4))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_Skeletor, {
                key: 0,
                class: "mx-auto mb-2",
                width: "300",
                height: "35"
              }))
            : (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_ctx.getFullName), 1))
        ]),
        (_ctx.getFriendRequests)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.getFriendRequests), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendPost && _ctx.sendPost(...args)), ["prevent"])),
          class: "my-5"
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("input", {
                    ref: "inputFile",
                    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                    class: "form-control",
                    type: "file",
                    id: "formFile",
                    name: "avatar",
                    accept: "image/*"
                  }, null, 544),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
                    class: "btn btn-primary",
                    type: "button",
                    name: "submit"
                  }, "Add Photo ")
                ])
              ]),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.linkInput) = $event)),
                onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendPost && _ctx.sendPost(...args)), ["exact","prevent"]), ["enter"])),
                type: "text",
                placeholder: "What's up?",
                class: "form-control search-field bg-light mb-2 tablinx-people__textarea"
              }, null, 544), [
                [_vModelText, _ctx.linkInput]
              ]),
              _hoisted_16
            ])
          ])
        ], 32)
      ])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
              return _createElementVNode("div", {
                key: index,
                class: "col-12 col-md-6 col-lg-4 mb-4"
              }, [
                _createVNode(_component_Skeletor, {
                  width: "100%",
                  height: "430"
                })
              ])
            }), 64))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (_ctx.getPosts.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPosts, (post) => {
                  return (_openBlock(), _createBlock(_component_PostCard, {
                    key: post._id,
                    post: post,
                    currentUserId: _ctx.currentUser.wpId
                  }, null, 8, ["post", "currentUserId"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 64))
}